import { createUTCDate } from "./date";

export function parseEvent(event) {
  event.datetime = createUTCDate(event.datetime);
  return event;
}
